import { ExternalLinkIcon, TriangleAlertIcon } from 'lucide-react'

import { ExternalLink } from '@/ui/atoms/link/Link'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/ui/atoms/tooltip/Tooltip'
import { links } from '@/ui/constants/links'
import { cn } from '@/ui/utils/style'

export function NotWhitelistedDelegationWarning({ className }: { className?: string }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <TriangleAlertIcon className={cn('icon-size-xs icon-system-error-primary', className)} />
      </TooltipTrigger>
      <TooltipContent>
        Delegate is not whitelisted. Under the current voting strategy, both your voting power and your delegate's will
        be counted as 0. No additional Spark Points will be rewarded.
        <br />
        Read more about it{' '}
        <ExternalLink to={links.docs.governance} variant="underline" className="inline-flex items-center gap-1">
          here <ExternalLinkIcon className="icon-size-xxs" />
        </ExternalLink>
        .
      </TooltipContent>
    </Tooltip>
  )
}
